<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>车队完成情况</h4>
    </div>
    <el-tabs v-model="activeName" style="margin-left:10px;" type="card" @tab-click="handleClick">
      <el-tab-pane label="车队完成情况" name="first">
        <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="85px" size="mini">
        <div class=" inpBox">
      <el-form-item label="时间:" prop="searchDate">
        <el-date-picker
          v-model="searchFrom.startTime"
          @change="startTimeChangeA"
          :editable="false"
          :clearable="false"
          size="mini"
          type="datetime"
          placeholder="选择日期">
        </el-date-picker>&nbsp;-&nbsp;&nbsp;
        <el-date-picker
          v-model="searchFrom.endTime"
          @change="startTimeChangeB"
          :editable="false"
          :clearable="false"
          size="mini"
          placeholder="选择日期"
          type="datetime"
        ></el-date-picker>
      </el-form-item>
        </div>
       <div class="searchBtnBox">
        <el-form-item>
          <el-button type="primary" @click="searchClick" btnCode='001P00AB001' v-if="btnFlg[0]">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="chongZhiClick" btnCode='001P00AB002' v-if="btnFlg[1]">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="firstDaoChu" btnCode='001P00AB003' v-if="btnFlg[2]">导出</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}" v-loading='tabLoading'>
      <el-table
        :data="tableList"
        ref="tableRef"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        @row-click = 'handleRowClick'
        @current-change="handleTabCurrentChange"
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <!-- <el-table-column type="selection"  width="55" align="center"></el-table-column> -->
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="purplanNo" label="采购日计划单号" width="220" align="center" ></el-table-column>
        <el-table-column prop="distributionNo" label="小计划号" align="center" width="200"></el-table-column>
        <el-table-column prop="fleetName" label="车队" align="center" width="220"></el-table-column>
        <el-table-column prop="forwarderName" label="货代" align="center" ></el-table-column>
        <el-table-column prop="shipName" label="船名" width="120" align="center"></el-table-column>
        <el-table-column prop="wharfxName" label="码头" align="center" width="120"></el-table-column>
        <el-table-column prop="goodsName" label="货物名称" align="center" width="140"></el-table-column>
        <el-table-column prop="distWeight" label="分配吨数（吨）" align="center" width="120" :formatter="formatterRowEmpty">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.distWeight == undefined || scope.row.distWeight == null || scope.row.distWeight == ''">-</span>
            <span v-else>{{scope.row.distWeight.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="ssuttleWeight" label="出港吨数" align="center" width="120" :formatter="formatterRowEmpty">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.ssuttleWeight == undefined || scope.row.ssuttleWeight == null || scope.row.ssuttleWeight == ''">-</span>
            <span v-else>{{scope.row.ssuttleWeight.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="sYssuttleWeight" label="出港剩余吨数" align="center" width="110" :formatter="formatterRowEmpty">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.sYssuttleWeight == undefined || scope.row.sYssuttleWeight == null || scope.row.sYssuttleWeight == ''">-</span>
            <span v-else>{{scope.row.sYssuttleWeight.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="wclSsuttle" label="出港完成率（%）" align="center" width="140" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="esuttleWeight" label="进厂吨数（吨）" width="120" align="center" :formatter="formatterRowEmpty">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.esuttleWeight == undefined || scope.row.esuttleWeight == null || scope.row.esuttleWeight == ''">-</span>
            <span v-else>{{scope.row.esuttleWeight.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="sYesuttleWeight" label="进厂剩余吨数" align="center" width="140" :formatter="formatterRowEmpty">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.sYesuttleWeight == undefined || scope.row.sYesuttleWeight == null || scope.row.sYesuttleWeight == ''">-</span>
            <span v-else>{{scope.row.sYesuttleWeight.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="wclEsuttle" label="进厂完成率（%）"  align="center" width="140" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="ssuttleNum"  label="出港车次" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="esuttlNnum" label="进厂车次"  align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="diffNum"    label="车次差异"  width="100" align="center" ></el-table-column>
        <el-table-column prop="aveEsuttleWeight" label="进厂平均单车载重（吨）" align="center" width="180" :formatter="formatterRowEmpty">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.aveEsuttleWeight == undefined || scope.row.aveEsuttleWeight == null || scope.row.aveEsuttleWeight == ''">-</span>
            <span v-else>{{scope.row.aveEsuttleWeight.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div >
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
      </el-tab-pane>
       <el-tab-pane label="车队完成情况统计" name="second">
         <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom1" ref="searchFrom1" class="demo-form-inline" label-width="85px" size="mini">
        <div class=" inpBox">
      <el-form-item label="时间:" prop="searchDate">
        <el-date-picker
          v-model="searchFrom1.startTime"
          @change="startTimeChangeC"
          :editable="false"
          :clearable="false"
          size="mini"
          type="datetime"
          placeholder="选择日期">
        </el-date-picker>&nbsp;-&nbsp;&nbsp;
        <el-date-picker
          v-model="searchFrom1.endTime"
          @change="startTimeChangeD"
          :editable="false"
          :clearable="false"
          size="mini"
          placeholder="选择日期"
          type="datetime"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="车队:" prop="fleetName">
        <el-select v-model="searchFrom1.fleetName" placeholder="请选择">
          <el-option
            v-for="(item,index) in fleetOptions"
            :key="index"
            :label="item.fleetName"
            :value="item.fleet">
          </el-option>
        </el-select>
      </el-form-item>
        </div>
       <div class="searchBtnBox">
        <el-form-item>
          <el-button type="primary" @click="searchClick2" btnCode='001P00AB004' v-if="btnFlg[3]">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="chongZhiClick2" btnCode='001P00AB005' v-if="btnFlg[4]">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="firstDaoChu2" btnCode='001P00AB006' v-if="btnFlg[5]">导出</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}" v-loading='tabLoadingB'>
      <el-table
        :data="tabList"
        ref="tableRef"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        @row-click = 'handleRowClick'
        @current-change="handleTabCurrentChange"
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <!-- <el-table-column type="selection"  width="55" align="center"></el-table-column> -->
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="fleetName" label="车队" align="center"></el-table-column>
        <el-table-column prop="" label="分配吨数（吨）" align="center" :formatter="formatterRowEmpty">
          <template slot-scope="scope">
            <span>{{scope.row.distWeight.toFixed(3)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ssuttleWeight" label="出港吨数（吨）" align="center" :formatter="formatterRowEmpty">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.ssuttleWeight == undefined || scope.row.ssuttleWeight == null || scope.row.ssuttleWeight == ''">-</span>
            <span v-else>{{scope.row.ssuttleWeight.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="wclSsuttle"   label="出港完成率（%）" align="center" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="esuttleWeight" label="进厂吨数（吨）"  align="center" :formatter="formatterRowEmpty">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.esuttleWeight == undefined || scope.row.esuttleWeight == null || scope.row.esuttleWeight == ''">-</span>
            <span v-else>{{scope.row.esuttleWeight.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="wclEsuttle"    label="进厂完成率（%）" align="center" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="ssuttleNum" label="出港车次" align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="esuttlNum" label="进厂车次" align="center" :formatter="formatterRowEmpty"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div >
      <el-pagination background
        @size-change="handleSizeChangeA"
        @current-change="handleCurrentChangeA"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="searchFrom1.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total1">
      </el-pagination>
    </div>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>
<script>
import {
  fleetList,
  getDictionaryList, // 字典
  fleetOverState, // 查询
  fleetOverCollect // 统计查询
} from '@/api/zhb-sgHarbour'
import { getBtn } from '@/utils/getButton'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { fileDownAll } from '@/utils/fileDownAll.js'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      activeName: 'first',
      // 按钮
      btnFlg: [],
      btnIdArr: ['001P00AB001', '001P00AB002', '001P00AB003',
        '001P00AB004', '001P00AB005', '001P00AB006'],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 10,
        startTime: '',
        endTime: ''
      },
      searchFrom1: {
        pageNo: 1,
        pageSize: 10,
        fleetName: '',
        startTime: '',
        endTime: ''
      },
      fleetOptions: [],
      value: '',
      tableList: [],
      tabList: [],
      total1: 0,
      tabLoading: false,
      tabLoadingB: false
    }
  },
  created () {
    this.fleetOptionsInit()
    this.getToDay()
    this.getSeatchData(this.searchFrom)
    this.getDictionaryList()
    this.btnFlg = getBtn(this.btnIdArr, '/sgStatistics/fleedFinish')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 150) + 'px'
  },
  methods: {
    fleetOptionsInit () {
      fleetList().then(res => {
        this.fleetOptions = res
        this.fleetOptions.unshift({ 'fleet': '', 'fleetName': '全部' })
      })
    },
    // 字典
    getDictionaryList () {
      getDictionaryList({
        groupNo: 'fleet_name'
      }).then(res => {
        // this.portOptions = res.wharf   // 港口
        // this.portOptions.unshift({'itemNo':'','showName':'全部'})
        // this.wharfOptions = res.wharf_1  // 码头
        // this.wharfOptions.unshift({'itemNo':'','showName':'全部'})
        // this.waybillStatusOptions = res.waybill_status   // 运单状态
        // this.waybillStatusOptions.unshift({'itemNo':'','showName':'全部'})
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 年月日格式化
    timeStamp: function (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log('time:' + JSON.stringify(now))
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    timeStamp2: function (value) { // 具体到时分秒
      var date = new Date(value) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var year = date.getFullYear()
      var month = ('0' + (date.getMonth() + 1)).slice(-2)
      var sdate = ('0' + date.getDate()).slice(-2)
      var hour = ('0' + date.getHours()).slice(-2)
      var minute = ('0' + date.getMinutes()).slice(-2)
      var second = ('0' + date.getSeconds()).slice(-2)
      // 拼接
      var result = year + '-' + month + '-' + sdate + ' ' + hour + ':' + minute + ':' + second
      // 返回
      return result
    },
    // 时间改变
    startTimeChangeA () {
      this.searchFrom.startTime = this.timeStamp2(this.searchFrom.startTime)
    },
    // 时间改变
    startTimeChangeB () {
      this.searchFrom.endTime = this.timeStamp2(this.searchFrom.endTime)
    },
    // 时间改变
    startTimeChangeC () {
      this.searchFrom1.startTime = this.timeStamp2(this.searchFrom1.startTime)
    },
    // 时间改变
    startTimeChangeD () {
      this.searchFrom1.endTime = this.timeStamp2(this.searchFrom1.endTime)
    },
    // 计划开始时间-当前日期早8点
    getToDay () {
      // 早八点之前显示昨天的日期，早八点之后显示今天的日期
      let dateStartStr = this.timeStamp2(new Date(new Date(new Date().toLocaleDateString()).getTime() + 28800000)) // 当天的早8点时间戳
      let dateEndStr = this.timeStamp2(new Date(new Date(new Date().toLocaleDateString()).getTime() + 43200000 * 3 - 14400000)) // 当天的早8点时间戳
      // console.log(dateEndStr)
      // console.log((new Date()).getTime(),'22222')  //当前时间戳
      let nowDate = (new Date()).getTime()
      // console.log(this.timeStamp2(new Date(dateStartStr).getTime()-86400000),'333')   // 早八点时间戳
      let morningTime = new Date(dateStartStr).getTime()
      if (nowDate > morningTime) { // 86400000 1天的毫秒
        this.searchFrom1.startTime = this.timeStamp2(new Date(dateStartStr).getTime() - 86400000)
        this.searchFrom1.endTime = this.timeStamp2(new Date(dateStartStr).getTime())
        this.searchFrom.startTime = this.timeStamp2(new Date(dateStartStr).getTime() - 86400000)
        this.searchFrom.endTime = this.timeStamp2(new Date(dateStartStr).getTime())
      } else {
        // 昨天的时间
        this.searchFrom1.startTime = this.timeStamp2(new Date(dateStartStr).getTime() - 86400000 - 86400000)
        this.searchFrom1.endTime = this.timeStamp2(new Date(dateStartStr).getTime())
        this.searchFrom.startTime = this.timeStamp2(new Date(dateStartStr).getTime() - 86400000 - 86400000)
        this.searchFrom.endTime = this.timeStamp2(new Date(dateStartStr).getTime())
      }
    },
    // tab切换
    handleClick (tab, event) {
      // console.log(tab, event)
      if (tab.index == 0) {
        this.getToDay()
        this.getSeatchData()
        this.searchFrom1 = {
          pageNo: 1,
          pageSize: 10,
          startTime: '',
          endTime: '',
          fleetName: ''
        }
      } else if (tab.index == 1) {
        this.getToDay()
        this.getStatistics()
        this.searchFrom = {
          pageNo: 1,
          pageSize: 10,
          startTime: '',
          endTime: ''
        }
      }
    },
    // 车队完成情况查询接口
    getSeatchData () {
      this.tabLoading = true
      fleetOverState({
        pageNo: this.searchFrom.pageNo,
        pageSize: this.searchFrom.pageSize,
        startTime: this.timeStamp2(this.searchFrom.startTime),
        endTime: this.timeStamp2(this.searchFrom.endTime)
      }).then(res => {
        this.tabLoading = false
        this.tableList = res.list
        this.total = res.total
      }).catch(err => {
        this.tabLoading = false
        // console.log(err.message)
        this.$message.error(err.message)
      })
    },
    getStatistics () {
      this.tabLoadingB = true
      fleetOverCollect({
        pageNo: this.searchFrom1.pageNo,
        pageSize: this.searchFrom1.pageSize,
        fleetId: this.searchFrom1.fleetName,
        startTime: this.timeStamp2(this.searchFrom1.startTime),
        endTime: this.timeStamp2(this.searchFrom1.endTime)
      }).then(res => {
        this.tabLoadingB = false
        this.tabList = res.list
        this.total1 = res.total
      }).catch(err => {
        this.tabLoadingB = false
        // console.log(err.message)
        this.$message.error(err.message)
      })
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData()
    },
    // 点击重置
    chongZhiClick () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 10,
        startTime: '',
        endTime: ''
      }
      this.getToDay()
      this.getSeatchData()
    },
    searchClick2 () {
      this.getStatistics()
    },
    chongZhiClick2 () {
      this.searchFrom1 = {
        pageNo: 1,
        pageSize: 10,
        startTime: '',
        endTime: ''
      }
      this.getToDay()
      this.getStatistics()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSeatchData(this.searchFrom)
    },
    // 每页条数
    handleSizeChangeA (val) {
      this.searchFrom1.pageSize = val
      this.getStatistics()
    },
    // 当前页
    handleCurrentChangeA (val) {
      this.searchFrom1.pageNo = val
      this.getStatistics()
    },
    // 点击选中
    handleRowClick (row) {
      // console.log(row)
      // this.$refs.tableRef.toggleRowSelection(row)
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },
    // 点击车队完成情况导出
    firstDaoChu () {
      this.$confirm('是否进行此操作？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          fileDownAll(
            '/zw56-zhb-ess-server/zhbess/waybill/fleetOverStateForExcel',
            this.searchFrom,
            '车队完成情况信息表',
            '.xls'
          )
        })
        .catch(() => {})
    },
    firstDaoChu2 () {
      this.$confirm('是否进行此操作？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          exportExcel(
            '/zw56-zhb-ess-server/zhbess/waybill/fleetOverCollectExcel',
            this.searchFrom1,
            '车队完成情况统计表'
          )
        })
        .catch(() => {})
    }

  }
}
</script>
<style scoped lang='less'>
.el-table{
overflow:visible !important;
}
/deep/ .el-tabs__item {
  width:150px;
  text-align: center;
  // background-color:#ccc ;
}
/deep/ .is-active{
  background-color:#409EFF;
  color: #fff;
}
.searchBox{
  margin-left: 15px;
}
.inpBox{
  margin: 10px 0 0 -35px;
}

 /deep/ .inpBox .el-range-editor--mini .el-input__inner {
   width: 180px;
}
/deep/ .inpBox .el-input__inner {
   width: 180px;
}
// .inpBox .el-date-editor{
//     width: 280px!important;
//  }
.searchBtnBox{
  margin-top: 10px;
  margin-left: -5px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
.tongJi{
  display: flex;
  margin-left:10px;
}
.tongJi_item{
  margin-right: 20px;
}
.tongJi_item span{
  color: red;
}
.daiPaiTop{
  width: 99%;
  margin: 20px auto;
  display: flex;
  justify-content: space-around;
  div{
    color: #909090;

  }
}
</style>
